export const SUGGESTIONS = {
  General: [
    'What’s the market outlook for renewable energy companies?',
    'Compare the efficiency of Zoom and Microsoft Teams for remote work.',
    'How has Satya Nadella influenced Microsoft’s cloud strategy?',
    'What’s the adoption trend for AI in healthcare?',
    'What products does Google offer in its cloud division?',
    'How does Netflix’s content strategy impact its revenue?',
    'Who are the key customers of SAP’s ERP solutions?',
    'What’s the future of electric vehicle technology?',
    'Analyze Amazon’s logistics performance and operational efficiency.',
    'What trends are shaping the cybersecurity industry?',
  ],
  RecommendedSoftware: [
    'What software should a small business use for customer relationship management?',
    'Which tools are recommended for project management in remote teams?',
    'What’s the best software for data analytics in the retail industry?',
    'Recommend software for improving supply chain efficiency in manufacturing.',
    'What tools should a marketing team use for campaign tracking?',
    'Which software is ideal for financial forecasting for startups?',
    'What’s the top recommended software for video conferencing in large enterprises?',
    'Recommend software for automating HR processes in mid-sized companies.',
    'What tools are best for cybersecurity in the healthcare sector?',
    'Which software should an e-commerce business use for inventory management?',
  ],
  BenchmarkCompanies: [
    'How does Apple’s financial performance compare to Samsung’s?',
    'What are the key products driving Amazon’s revenue growth?',
    'Benchmark Tesla’s market share against Toyota in the electric vehicle sector.',
    'How does Google’s cloud division performance stack up against Microsoft Azure?',
    'What trends define the top-performing companies in the renewable energy sector?',
    'Compare the operational efficiency of Walmart and Target using reliable business signals.',
    'How does Netflix benchmark against Disney+ in subscriber growth and content investment?',
    'What sets the leading financial institutions apart in sustainability metrics?',
    'Benchmark the customer satisfaction signals of Salesforce and HubSpot.',
    'How do the R&D investments of Pfizer and Moderna compare in the pharmaceutical industry?',
  ],
  AnalyzeTechStacksForCompanies: [
    'Analyze the software products offered by Adobe using official and market sources.',
    'What software products does Salesforce provide based on their official sources?',
    'Identify the software products of Microsoft using job postings and website data.',
    'Conduct an analysis of Oracle’s software products with evidence from primary and secondary sources.',
    'What are the software products of SAP based on official product information?',
    'List the software products offered by Zoom, focusing on data from their website and social media.',
    'Analyze IBM’s software products using LinkedIn profiles and industry reports.',
    'What software does HubSpot offer according to their official website and X posts?',
    'Identify the software products of Autodesk with a focus on market positioning and product signals.',
    'Conduct a comprehensive analysis of software products from ServiceNow using all available sources.',
  ],
  FindCustomersOfProducts: [
    'Analyze companies using Salesforce for customer relationship management.',
    'Identify organizations leveraging Microsoft Azure for cloud computing solutions.',
    'List companies adopting SAP ERP for enterprise resource planning.',
    'Conduct an analysis of firms using Adobe Creative Cloud for design and media production.',
    'What organizations are utilizing Zoom for video conferencing and collaboration?',
    'Benchmark companies implementing Oracle NetSuite for financial management.',
    'Analyze the use of ServiceNow by companies for IT service management.',
    'Identify businesses using HubSpot for marketing automation and CRM.',
    'List companies that rely on Autodesk software for design and engineering tasks.',
    'Conduct a comprehensive analysis of organizations using Slack for team communication.',
  ],
  AnalyzeProduct: [
    'Analyze Monday.com for project management and CRM capabilities.',
    'Conduct a comprehensive analysis of AWS for cloud infrastructure and services.',
    'Evaluate Oracle Fusion Cloud ERP for enterprise resource planning.',
    'Analyze Figma for collaborative design and prototyping features.',
    'Assess Microsoft Teams for team collaboration and communication functionalities.',
    'Benchmark QuickBooks for financial management and accounting performance.',
    'Analyze Jira for agile project management and issue tracking capabilities.',
    'Evaluate Zoho CRM for customer relationship management and automation features.',
    'Assess SolidWorks for 3D CAD design and engineering functionalities.',
    'Conduct a comprehensive analysis of Trello for task management and workflow organization.',
  ],
  TrendAnalysis: [
    'Analyze the AI CRM trend and its impact on Salesforce, HubSpot, and Clay.',
    'What trends are shaping cybersecurity vendors for enterprise buyers?',
    'Analyze adoption trends for Microsoft Copilot across productivity software and enterprise workflows.',
    'Compare the trend momentum of Snowflake, Databricks, and BigQuery in cloud data platforms.',
    'Analyze the trend outlook for ServiceNow in AI-powered IT service management.',
    'What are the key trends affecting ERP vendors like SAP, Oracle, and Workday?',
    'Analyze market trends for sales intelligence products and vendors such as ZoomInfo, Apollo, and Cognism.',
    'What is the trend outlook for design collaboration tools like Figma, Canva, and Adobe Express?',
    'Analyze the trend risks and opportunities for open-source database vendors.',
    'Create a trend map for AI agents in customer support, including adoption drivers and competitive threats.',
  ],
  FindEmployeesOfCompanies: [
    'List current employees at Snowflake with validated data in table format.',
    'Give me a structured table of top staff at Palantir, sorted by seniority.',
    'Find up to 25 verified current employees at Stripe, include core skills.',
    'Show a table of current engineers and leadership at OpenAI.',
    'Pull current team data for UiPath — only verified roles and skills.',
    'Retrieve employee insights for Revolut. Include LinkedIn and location.',
    'Generate a table of senior staff at Atlassian with current titles and skills.',
    'Find active employees at Databricks. Sort by role level.',
    'Give me a validated staff table for Canva, from C-level to ICs.',
    'Create a structured employee profile table for GitLab using verified sources.',
    'Show the top 25 contacts at Nvidia in Logistic Department',
    'Show experts in SQL at Snowflake',
  ],
  ApiDocs: [
    'How do I authenticate with the BuyerCaddy API?',
    'What are the main endpoints available in the BuyerCaddy API?',
    'Show me an example of how to search for companies using the API.',
    'How can I retrieve the tech stack of a company via API?',
    'What is the base URL for the BuyerCaddy API?',
    'How do I get a list of products in a specific category?',
    'Are there any rate limits for the BuyerCaddy API?',
    'How do I check my remaining API credits?',
    'Show me the schema for a company object in the API.',
    'How do I find customers of a specific product using the API?',
  ],
};
